/**
 * シフト(2026-09-12)。3つのタブをまとめる画面。
 *  - シフト提出: 本人が「その月のどの日に何時から何時まで入れるか」を出す(ShiftSubmitTab)
 *  - シフト表: 月間の一覧。提出されたものが確定、管理者が直したセルは変更履歴つき(ShiftMonthTab。D-130)
 *  - 出勤表: その日の席・割振・時間(AttendanceTab)。現行「シフト表」タブと同じ並び
 *  - 変更申請: 提出後の変更を 理由つきで申請 → 管理者が承認(ShiftChangeTab。2026-09-20 D-113)
 * タブは URL(?tab=)に持つので、戻るボタンで戻れる。
 * 2026-09-20 UIデザインシステムへ移行(D-99)。タブは SegmentedControl、枠は FilterBar。
 */
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '@core/auth/AuthProvider';
import FilterBar from '@core/components/ui/FilterBar';
import PageHeader from '@core/components/ui/PageHeader';
import SegmentedControl from '@core/components/ui/SegmentedControl';
import type { DateStr } from '@core/lib/types';
import AttendanceTab from './AttendanceTab';
import ShiftMonthTab from './ShiftMonthTab';
import ShiftSubmitTab from './ShiftSubmitTab';
import ShiftChangeTab from './ShiftChangeTab';
import ShiftNoticePanel from './ShiftNoticePanel';

type Tab = 'submit' | 'month' | 'attendance' | 'change';
const TABS: { key: Tab; label: string }[] = [
  { key: 'attendance', label: '出勤表' },
  { key: 'month', label: 'シフト表' },
  { key: 'submit', label: 'シフト提出' },
  { key: 'change', label: '変更申請' },
];

export default function ShiftPage() {
  const { isAdmin } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = ((params.get('tab') as Tab | null) ?? 'attendance') as Tab;

  const go = (next: Partial<{ tab: Tab; date: DateStr }>) => {
    const p = new URLSearchParams(params);
    if (next.tab) p.set('tab', next.tab);
    if (next.date) p.set('date', next.date);
    setParams(p);
  };

  return (
    <div className="screen full">
      <PageHeader title="シフト" />
      <FilterBar label="表示する内容">
        <SegmentedControl label="表示する内容" options={TABS.map((t) => ({ key: t.key, label: t.label }))} value={tab} onChange={(v) => go({ tab: v as Tab })} />
        {!isAdmin && <span className="ui-hint">出勤表は自分の行だけ表示されます</span>}
      </FilterBar>
      {/* 管理者がシフトを直したときのお知らせ(本人だけ。D-130) */}
      <ShiftNoticePanel />

      {tab === 'submit' && <ShiftSubmitTab />}
      {tab === 'month' && <ShiftMonthTab onOpenDate={(d) => go({ tab: 'attendance', date: d })} />}
      {tab === 'attendance' && <AttendanceTab />}
      {tab === 'change' && <ShiftChangeTab />}
    </div>
  );
}
